import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataFormRequest, DataFormEvent } from 'app/shared/components/data-form/data-form.model';

export interface DrawerFormResult {
    type: 'submit' | 'cancel';
    event?: DataFormEvent;
}

@Injectable({
    providedIn: 'root',
})
export class DrawerFormService {
    private readonly _openFormRequest = new BehaviorSubject<DataFormRequest | null>(null);
    private _resultSubject: Subject<DrawerFormResult> | null = null;

    get openFormRequest$(): Observable<DataFormRequest | null> {
        return this._openFormRequest.asObservable();
    }

    /**
     * Opens the app-level data-form drawer with the given request.
     * Returns an Observable that emits once when the form is submitted or cancelled,
     * then completes.
     */
    openForm(request: DataFormRequest): Observable<DrawerFormResult> {
        if (this._resultSubject) {
            this._resultSubject.complete();
        }
        this._resultSubject = new Subject<DrawerFormResult>();
        this._openFormRequest.next(request);
        return this._resultSubject.asObservable().pipe(take(1));
    }

    /** Called by app.component when the data-form emits submitForm */
    emitSubmit(event: DataFormEvent): void {
        if (this._resultSubject) {
            this._resultSubject.next({ type: 'submit', event });
            this._resultSubject.complete();
            this._resultSubject = null;
        }
        this._openFormRequest.next(null);
    }

    /** Called by app.component when the data-form emits cancelForm */
    emitCancel(): void {
        if (this._resultSubject) {
            this._resultSubject.next({ type: 'cancel' });
            this._resultSubject.complete();
            this._resultSubject = null;
        }
        this._openFormRequest.next(null);
    }
}
